import { graphql } from 'src/graphql';

export const UpdateUserLanguage = graphql(`
  mutation updateUserLanguage($user: UserInput!) {
    updateMe(user: $user) {
      _id
      settings {
        language
      }
    }
  }
`);
